import type { PageContext } from 'vike/types';

export default function title(pageContext: PageContext) {
  const fiche = (pageContext.data as { fiche?: { code: string; label: string } } | undefined)?.fiche;
  if (!fiche) return 'Fiche CEE | Solution Éco France';
  return `${fiche.code} — ${fiche.label} | Solution Éco France`;
}
